import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ENVIRONMENT } from '@cfp/core';
import { Button, FormGroupComponent, InputText, ValidationFeedback } from '@cfp/ui';
import { TranslateModule } from '@ngx-translate/core';
import { PasswordService } from 'csr-login-app';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { LoginMessages } from '../login-messages';

@Component({
  selector: 'cfp-forgot-password-modal',
  templateUrl: './forgot-password-modal.html',
  imports: [
    LoginMessages,
    TranslateModule,
    ReactiveFormsModule,
    Button,
    ValidationFeedback,
    InputText,
    FormGroupComponent
  ]
})
export class ForgotPasswordModal implements OnInit {
  public loading: boolean = false;
  public form: FormGroup;
  public successMessages: string[] = [];
  public warningMessages: string[] = [];
  public errorMessages: string[] = [];

  private readonly environment = inject(ENVIRONMENT);
  private readonly formBuilder = inject(FormBuilder);
  private readonly bsModalRef = inject(BsModalRef);
  private readonly passwordService = inject(PasswordService);

  public ngOnInit(): void {
    const group = {
      username: ['', Validators.required]
    };

    this.form = this.formBuilder.group(group);
  }

  protected isFieldValid(field: string): boolean {
    return this.form.get(field)?.valid ?? false;
  }

  protected hide(): void {
    this.bsModalRef.hide();
  }

  protected submitForm(): void {
    this.loading = true;

    this.passwordService
      .v2PasswordForgotpasswordPost({
        username: this.form.value.username,
        environmentCode: this.environment.environmentCode.dto
      })
      .subscribe({
        next: () => {
          this.loading = false;
          this.successMessages = ['login.success.requestPasswordReset'];
        },
        error: () => {
          this.loading = false;
        }
      });
  }
}
